export * from './api';
import get from 'lodash/get';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  URL_ORDERS_VIEW_ONE, URL_LOSS_ADJUSTMENT_ORDER_VIEW_ONE,
  URL_TIRE_FITTING_ORDER_VIEW_ONE, URL_TIRE_STORAGE_ORDER_VIEW_ONE,
  URL_ORDERS_VIEW_ONE_EVACUATOR, URL_ORDERS_VIEW_ONE_TECH_SERVICE,
  URL_LOSS_ADJUSTMENT_ORDERS,
  URL_ORDERS, URL_EVACUATOR_ORDERS, URL_TIRE_FITTING_ORDERS,
} from 'lib/router/url';
import {
  SERVICE_61_EXPERT_APPOINTMENT, SERVICE_68_TIRE_FITTING_STATIONARY,
  SERVICE_69_TIRE_STORAGE_STATIONARY,
  SERVICE_CALL_TOW_TRUCK,
  SERVICE_CALL_MANIPULATOR_TRUCK,
  SERVICE_BRING_FUEL, SERVICE_REPLACE_WHEEL, SERVICE_OPEN_DOOR, SERVICE_START_ENGINE,
} from 'modules/core/constants/services';
/* --------- FOR USE INSIDE REACT CLASSES----------- */

export const printMoney = (sum, coins = 0, currency = 'RUB', format = 'ru-RU', hideCurrency = true) => {
  const numberFormat = new Intl.NumberFormat(format, {
    currency,
    style: 'currency',
    minimumFractionDigits: coins,
  });
  const res = String(numberFormat.format(sum));
  return hideCurrency ? res.substr(0, res.length - 1) : res;
};

// Функция для управления  z-index в модальных формах.
// без этой функции модальные окна под другими модальными окнами не закрашиваются серым
export const setZIndexForModalForms = () => {
  setTimeout(() => {
    const c = document.querySelectorAll('.modal-backdrop') as any as Array<HTMLElement>;
    c.forEach((v, i) => {
      c[i].style.zIndex = (1040 + i * 20).toString();
    });
    const d = document.querySelectorAll('.modal.fade') as any as Array<HTMLElement>;
    d.forEach((v, i) => {
      d[i].style.zIndex = (1050 + i * 20).toString();
    });
  }, 20);
};

// isDev - если на Dev-среде запускается система. Надо для разблокировки кнопок Добавления в синхронизируемых справочниках
export const isDev = document.domain.includes('dev.avtoapp.online') || document.domain.includes('127.0.0.1') || document.domain.includes('localhost');

// Функции сохранения значений в localStorage
const storage = localStorage;

export const getSettings = (settingsKey, key = null, defaults = null) => {
  const settings = JSON.parse(storage.getItem(settingsKey)) || {};
  return key ? get(settings, key, defaults) : settings;
};

export const updateSettings = (settingsKey, settings) => {
  storage.setItem(settingsKey, JSON.stringify({
    ...getSettings(settingsKey),
    ...settings,
  }));
};

// функции "очистки" телефона
export const getPhoneParsed = (values) => {
  if (!values?.phoneMobile) return undefined;
  // eslint-disable-next-line no-useless-escape
  const bPhone = values?.phoneMobile.replace(/[^\d\+]/g, '');
  return parsePhoneNumberFromString(bPhone.includes('+7') ? bPhone : `+7${ bPhone }`);
};

export const getPhoneParsedString = (phoneString) => {
  // eslint-disable-next-line no-useless-escape
  const bPhone = phoneString.replace(/[^\d\+]/g, '');
  return bPhone.includes('+7') ? bPhone : `+7${ bPhone }`;
};

// функция для получения цвета контраста (черный или белый) в зависимости от заданного цвета фона
export const getContrastColor = (bgColor) => {
  // Задаём хоть какой-то входной цвет
  bgColor = bgColor ?? '#000000';

  // Удаляем #, если он есть
  bgColor = bgColor.replace('#', '');

  // Проверяем корректность HEX-цвета
  if (bgColor.length !== 6) {
    throw new Error('Некорректный HEX-цвет. Используйте формат #RRGGBB или RRGGBB.');
  }

  // Разбиваем на компоненты R, G, B и нормализуем в [0, 1]
  const r = parseInt(bgColor.substring(0, 2), 16) / 255;
  const g = parseInt(bgColor.substring(2, 4), 16) / 255;
  const b = parseInt(bgColor.substring(4, 6), 16) / 255;

  // Вычисляем относительную яркость (по формуле WCAG 2.0)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Выбираем чёрный или белый в зависимости от яркости
  return luminance > 0.5 ? '#000000' : '#FFFFFF';
}

// функция для получения цвета контраста в зависимости от заданного цвета фона
// Поддержка 3-значного HEX (например, #FFF → #FFFFFF).
// Гибкие настройки цветов через параметр options:
// darkColor — цвет для светлого фона (по умолчанию #333333).
// lightColor — цвет для тёмного фона (по умолчанию #F0F0F0).
// threshold — порог яркости (по умолчанию 0.5).
// Обработка ошибок при некорректном HEX.

// // Кастомные цвета
// console.log(getContrastColor("#FFFFFF", { darkColor: "#222222" })); // → "#222222"
// console.log(getContrastColor("#000000", { lightColor: "#E1E1E1" })); // → "#E1E1E1"
// // Изменённый порог яркости (например, для более агрессивного контраста)
// console.log(getContrastColor("#888888", { threshold: 0.6 })); // → "#333333"
export const getContrastMultiColor = (bgColor, options = {}) => {
  // Удаляем #, если он есть
  bgColor = bgColor.replace('#', '');

  // Проверяем корректность HEX-цвета
  if (bgColor.length !== 3 && bgColor.length !== 6) {
    throw new Error('Некорректный HEX-цвет. Используйте формат #RRGGBB, RRGGBB, #RGB или RGB.');
  }

  // Если HEX сокращённый (например, "FFF"), преобразуем в полный формат
  if (bgColor.length === 3) {
    bgColor = bgColor.split('').map((c) => c + c).join('');
  }

  // Разбиваем на R, G, B и нормализуем в [0, 1]
  const r = parseInt(bgColor.substring(0, 2), 16) / 255;
  const g = parseInt(bgColor.substring(2, 4), 16) / 255;
  const b = parseInt(bgColor.substring(4, 6), 16) / 255;

  // Вычисляем относительную яркость (WCAG 2.0)
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  // Настройки цветов по умолчанию
  const defaultOptions = {
    darkColor: '#333333', // Тёмно-серый вместо чёрного
    lightColor: '#F0F0F0', // Светло-серый вместо белого
    threshold: 0.5, // Порог яркости
  };

  // Объединяем с переданными options
  const opts = { ...defaultOptions, ...options };

  // Выбираем цвет на основе яркости
  return luminance > opts.threshold ? opts.darkColor : opts.lightColor;
}

// сервисы тех.помощи - единая заявка (редизайн)
const TECH_SERVICE_IDS = [
  SERVICE_BRING_FUEL, SERVICE_REPLACE_WHEEL, SERVICE_OPEN_DOOR, SERVICE_START_ENGINE,
];

// функция определяет URL для перехода
export const urlSelector = (serviceId: number) => {
  // const isProduction = process.env.NODE_ENV === 'production';

  if (serviceId === SERVICE_61_EXPERT_APPOINTMENT) {
    return `${ URL_LOSS_ADJUSTMENT_ORDER_VIEW_ONE }`;
  } else if (serviceId === SERVICE_68_TIRE_FITTING_STATIONARY) {
    return `${ URL_TIRE_FITTING_ORDER_VIEW_ONE }`;
  } else if (serviceId === SERVICE_69_TIRE_STORAGE_STATIONARY) {
    return `${ URL_TIRE_STORAGE_ORDER_VIEW_ONE }`;
  } else if (serviceId === SERVICE_CALL_TOW_TRUCK) {
    return `${ URL_ORDERS_VIEW_ONE_EVACUATOR }`;
  } else if (serviceId === SERVICE_CALL_MANIPULATOR_TRUCK) {
    return `${ URL_ORDERS_VIEW_ONE_EVACUATOR }`;
  } else if (TECH_SERVICE_IDS.includes(serviceId)) {
    return `${ URL_ORDERS_VIEW_ONE_TECH_SERVICE }`;
  } else {
    return `${ URL_ORDERS_VIEW_ONE }`;
  }
}

// функция определяет URL для перехода в списки по сервису (нужна для onExit-функций )
export const urlListSelector = (serviceId: number) => {
  if (serviceId === SERVICE_61_EXPERT_APPOINTMENT) {
    return `${ URL_LOSS_ADJUSTMENT_ORDERS }`;
  } else if (serviceId === SERVICE_68_TIRE_FITTING_STATIONARY) {
    return `${ URL_TIRE_FITTING_ORDERS }`;
  } else if (serviceId === SERVICE_69_TIRE_STORAGE_STATIONARY) {
    return `${ URL_TIRE_FITTING_ORDERS }`;
  } else if (serviceId === SERVICE_CALL_TOW_TRUCK) {
    return `${ URL_EVACUATOR_ORDERS }`;
  } else if (serviceId === SERVICE_CALL_MANIPULATOR_TRUCK) {
    return `${ URL_EVACUATOR_ORDERS }`;
  } else if (TECH_SERVICE_IDS.includes(serviceId)) {
    return `${ URL_EVACUATOR_ORDERS }`;
  } else {
    return `${ URL_ORDERS }`;
  }
}

// Округление до указанного количества знаков после запятой
export const roundTo = (value: number, decimals: number = 2): number => {
  if (!isFinite(value)) return value;
  const multiplier = Math.pow(10, decimals);
  return Math.round(value * multiplier) / multiplier;
};

// форматирование числа
export const formatNumber = (value: number | undefined, decimals: number = 2): string => {
  if (value == null || isNaN(value)) return '';
  return roundTo(value, decimals).toLocaleString('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
};
